export const ResourceUtil = {
    fileTypeMap :{
        VIDEO: ['mp4','flv','avi','mov','mkv','m4v','ts'],
        AUDIO: ['mp3', 'flac', 'm4a', 'ogg'],
        DOCUMENT: ['pdf', 'ppt', 'pptx', 'doc', 'docx', 'xls', 'xlsx', 'txt', 'json'],
        ZIP: ['zip', 'rar', 'tar'],
        PICTURE: ['jpg', 'png', 'jpeg', 'gif'],
        LINK: ['url']
    },
    fileShowMap:(showType: string) => {
        if (showType === 'VIDEO'){
            return {
                type: 'VIDEO',
                name: '视频',
                tip: '单个视频文件需小于10GB，视频上传后将自动进行多清晰度转码，转码需要一定时间。上传过程中请勿关闭或切换页面',
                patternDom: ''
            }
        } else if (showType === 'AUDIO'){
            return {
                type: 'AUDIO',
                name: '音频',
                tip: '音频上传后将自动进行多格式转码，转码需要一定时间',
                patternDom: ''
            }
        } else if (showType === 'DOCUMENT' || showType === 'LINK' || showType === 'PICTURE'|| showType === 'ZIP'){
            return {
                type: 'DOCUMENT',
                name: '文档',
                tip: '',
                patternDom: ''
            }
        } else if (showType === 'LIVE'){
            return {
                type: 'LIVE',
                name: '直播',
                tip: '',
                patternDom: ''
            }
        } else if (showType === 'RESOURCE'){
            return {
                type: 'RESOURCE',
                name: '资源',
                tip: '',
                patternDom: ''
            }
        }
    },
    getFileSize: (limit: number) => {
        var size = "";  
        if( limit < 0.1 * 1000 ){ //如果小于0.1KB转化成B
            size = limit.toFixed(2) + "B";    
         }else if(limit < 0.1 * 1000 * 1000 ){//如果小于0.1MB转化成KB  
            size = (limit / 1000).toFixed(2) + "KB";              
         }else if(limit < 0.1 * 1000 * 1000 * 1000){ //如果小于0.1GB转化成MB  
             size = (limit / (1000 * 1000)).toFixed(2) + "MB";  
         }else{ //其他转化成GB  
             size = (limit / (1000 * 1000 * 1000)).toFixed(2) + "GB";  
        }            
        var sizestr = size + "";   
        var len = sizestr.indexOf("\.");  
        var dec = sizestr.substr(len + 1, 2);  
        if(dec == "00"){//当小数点后为00时 去掉小数部分  
            return sizestr.substring(0,len) + sizestr.substr(len + 3,2);  
        }  
        return sizestr;
    },
    getFileDuration: (val: number) => {
        if(val<60){
            return val + "秒";
        }else{
            let min_total = Math.floor(val / 60); // 分钟
            let sec = Math.floor(val % 60); // 余秒
            if(min_total<60){
                return min_total + "分钟" + sec + "秒";
            }else{
                let hour_total = Math.floor(min_total / 60); // 小时数
                let min = Math.floor(min_total % 60); // 余分钟
                return hour_total + "小时" + min + "分钟" + sec + "秒";
            }
        }
    }
}